import React from "react";
import { Link } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import Modal from "react-bootstrap/Modal";
import * as Yup from "yup";
import { useSnackbar } from "notistack";
import { contactUs } from "../shared/_services/common.services";

const ContactUsModal = ({ onClose }) => {
  const { enqueueSnackbar } = useSnackbar();

  const initialValues = {
    subject: "",
    message: "",
  };

  const validationSchema = Yup.object().shape({
    subject: Yup.string().required("Subject is required"),
    message: Yup.string().required("Message is required"),
  });

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    const user = JSON.parse(localStorage.getItem("currentUser"));
    const email = user?.user?.email;
    const userType = user?.user?.userType;
    const { subject, message } = values;
    try {
      await contactUs(email, subject, message,userType);
      enqueueSnackbar("Message sent successfully", { variant: "success" });
      resetForm();
      onClose();
    } catch (error) {
      enqueueSnackbar("Failed to send message", { variant: "error" });
    }
    setSubmitting(false);
  };

  return (
    <Modal
      className="contactUsPopup"
      show={true} // Always show modal when rendered
      onHide={onClose} // Handle closing modal
      aria-labelledby="contactUsPopupLabel"
      backdrop="static"
      keyboard={false}
      centered
    >
      <div className="modal-body">
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ errors, touched, isSubmitting }) => (
            <Form>
              <div className="row">
                <div className="col-md-12">
                  <div className="d-flex justify-content-between">
                    <h5>Let’s get in touch</h5>
                    <Link
                      className="close-popup-btn"
                      type="button"
                      onClick={onClose}
                    >
                      <i className="fa fa-times"></i>
                    </Link>
                  </div>
                  <p className="f-300">
                    We would love to connect and learn more about you.
                  </p>
                  <div className="form-group">
                    <Field
                      type="text"
                      id="subject"
                      name="subject"
                      placeholder="Subject"
                      className={`form-control ${errors.subject && touched.subject ? "is-invalid" : ""
                        }`}
                    />
                    <ErrorMessage
                      name="subject"
                      component="div"
                      className="invalid-feedback"
                    />
                  </div>
                  <div className="form-group">
                    <Field
                      as="textarea"
                      id="message"
                      name="message"
                      placeholder="Let us know how we can help"
                      className={`form-control ${errors.message && touched.message ? "is-invalid" : ""
                        }`}
                      rows="3"
                    />
                    <ErrorMessage
                      name="message"
                      component="div"
                      className="invalid-feedback"
                    />
                  </div>
                </div>
                <div className="col-12 mt-3 text-center">
                  <button
                    type="submit"
                    className="as-btn-primary w-25"
                    disabled={isSubmitting}
                  >
                    Send
                  </button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </Modal>
  );
};

export default ContactUsModal;
